"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.path = exports.requestSchema = void 0;
const zod_1 = require("zod");
const admin_1 = require("../../shared-types/admin");
exports.requestSchema = zod_1.z.object({
    name: zod_1.z.string(),
    description: zod_1.z.string(),
    roleType: admin_1.PermissionEntityTypeSchema,
    permissions: zod_1.z.array(zod_1.z.string()),
    id: zod_1.z.number().optional(),
});
exports.path = '/admin-upsert-role';
//# sourceMappingURL=index.js.map